module.exports = __webpack_public_path__ + "static/media/Арабов М.К..e13412ff.pdf";